import { useEffect, useState } from 'react'
import './App.css'
import FloorCard from './components/FloorCard'
import ActionCard from './components/ActionCard'

const floorCardImages = [
	{
		src: './assets/card_goblin_raider.png',
		disabled: false,
		type: 'monster',
		deck: 'floor',
		flipped: false,
		locked: false,
	},
	{
		src: './assets/card_healing_potion.png',
		disabled: false,
		type: 'potion',
		deck: 'floor',
		flipped: false,
		locked: false,
	},
	{
		src: './assets/card_treasure_chest.png',
		disabled: false,
		type: 'treasure',
		deck: 'floor',
		flipped: false,
		locked: false,
	},
	{
		src: './assets/card_spell_book.png',
		disabled: false,
		type: 'spell',
		deck: 'floor',
		flipped: false,
		locked: false,
	},
]
const actionCardImages = [
	{ src: './assets/button_potion.png', disabled: true, type: 'heal', deck: 'action' },
	{ src: './assets/button_attack.png', disabled: false, type: 'attack', deck: 'action' },
	{ src: './assets/button_spell.png', disabled: true, type: 'magic', deck: 'action' },
]
let playerStats = {
	hp: 15,
	atk: 5,
}
let monsterStats = {
	hp: 0, // 7 when active
	atk: 2,
}
let flipTimer = 500

const attackSound = new Audio('./assets/attack.wav')
const bookSound = new Audio('./assets/book.wav')
const emptySound = new Audio('./assets/empty.wav')
const flipSound = new Audio('./assets/flip.wav')
const goblinSound = new Audio('./assets/goblin.wav')
const healSound = new Audio('./assets/heal.wav')
const potionSound = new Audio('./assets/potion.wav')
const spellSound = new Audio('./assets/spell.wav')
const treasureSound = new Audio('./assets/treasure.wav')
const music = new Audio('./assets/music.wav')

function App() {
	const [floorCards, setFloorCards] = useState([])
	const [actionCards, setActionCards] = useState([])
	const [score, setScore] = useState(0)
	const [playerState, setPlayerState] = useState(playerStats)
	const [monsterState, setMonsterState] = useState(monsterStats)
	const [playerTurn, setPlayerTurn] = useState(true)
	const [floorCardSelected, setFloorCardSelected] = useState(null)
	const [actionCardSelected, setActionCardSelected] = useState(null)
	const [potionInv, setPotionInv] = useState(false)
	const [spellInv, setSpellInv] = useState(false)
	const [gameState, setGameState] = useState({ gameOver: false, nextRoomReady: false })
	const [modalOpen, setModalOpen] = useState(true)
	const [levelCounter, setLevelCounter] = useState(1)

	// INIT FUNCTIONS

	const shuffleCards = () => {
		const shuffledCards = [...floorCardImages, ...floorCardImages, ...floorCardImages]
			.sort(() => Math.random() - 0.5)
			.map(card => ({ ...card, id: Math.random() }))
		setFloorCardSelected(null)
		setFloorCards(shuffledCards)
	}
	const updateActionCards = () => {
		setActionCardSelected(null)
		const actionCards = [...actionCardImages].map(card => ({ ...card, id: Math.random() }))
		setActionCards(actionCards)
	}

	music.loop = true
	music.volume = 0.2
	music.play()
	// FLOOR SELECTION HANDLER

	const handleFloorSelection = card => {
		if (card.deck === 'floor' && !floorCardSelected && playerTurn) {
			setFloorCardSelected({ ...card, flipped: true })
			flipSound.play()
			if (card.type === 'treasure') {
				const randomScore = Math.floor(Math.random() * (50 - 10 + 1)) + 10
				setTimeout(() => {
					setFloorCardSelected({ ...card, flipped: true, disabled: true })
					setScore(prevScore => prevScore + randomScore)
					treasureSound.play()
				}, flipTimer)
			} else if (card.type === 'potion') {
				if (!potionInv) {
					setTimeout(() => {
						setFloorCardSelected({ ...card, flipped: true, disabled: true })
						setPotionInv(true)
						potionSound.play()
					}, flipTimer)
				} else {
					setTimeout(() => {
						setFloorCardSelected({ ...card, flipped: true, disabled: true })
						emptySound.play()
					}, flipTimer)
				}
			} else if (card.type === 'spell') {
				if (!spellInv) {
					setTimeout(() => {
						setFloorCardSelected({ ...card, flipped: true, disabled: true })
						setSpellInv(true)
						bookSound.play()
					}, flipTimer)
				} else {
					setTimeout(() => {
						setFloorCardSelected({ ...card, flipped: true, disabled: true })
						emptySound.play()
					}, flipTimer)
				}
			} else if (card.type === 'monster') {
				setFloorCardSelected({ ...card, flipped: true })
				setMonsterState(prevState => {
					return { ...prevState, hp: 7 }
				})
			}
			setTimeout(() => {
				setPlayerTurn(false)
			}, 100)

			setTimeout(() => {
				setFloorCardSelected(null)
				setPlayerTurn(true)
			}, 1000)
		}
		// X if treasure, add 7 to score and disable, start player turn
		// X if item, check item type, then check inventory, then add to appropriate inventory and/or disable, start player turn
		// X if monster, attack player, start player turn (make all floor cards not clickable, only action cards)
	}

	// ACTION SELECTION HANDLER

	const handleActionSelection = card => {
		if (card.deck === 'action' && !actionCardSelected && playerTurn) {
			setActionCardSelected(card)
			if (card.type === 'heal') {
				const newHP = playerState.hp + 5
				if (15 - playerState.hp <= 5) {
					setPlayerState(prevState => {
						healSound.play()
						return { ...prevState, hp: 15 }
					})
				} else {
					setPlayerState(prevState => {
						healSound.play()
						return { ...prevState, hp: newHP }
					})
				}
				setPotionInv(false)
			}
			if (card.type === 'attack') {
				if (monsterState.hp > 0) {
					setMonsterState(prevState => {
						attackSound.play()
						const newHP = prevState.hp - 4
						return { ...prevState, hp: newHP }
					})
				}
			}
			if (card.type === 'magic') {
				if (monsterState.hp > 0) {
					setMonsterState(prevState => {
						spellSound.play()
						const newHP = prevState.hp - 8
						return { ...prevState, hp: newHP }
					})
					setSpellInv(false)
				}
			}
			setTimeout(() => {
				setPlayerTurn(false)
				//console.log('end player turn')
			}, 100)
			setTimeout(() => {
				setActionCardSelected(null)
				setPlayerTurn(true)
				//console.log('start player turn')
			}, 1000)
		}
	}

	// MAKES CARDS FLIPPED OR DISABLED BASED ON THE SELECTION

	useEffect(() => {
		//console.log('floor: ' + JSON.stringify(floorCardSelected))
		//console.log('action: ' + JSON.stringify(actionCardSelected))
		if (floorCardSelected) {
			setFloorCards(prevCards => {
				return prevCards.map(card => {
					if (card.id === floorCardSelected.id) {
						if (floorCardSelected.disabled) {
							return { ...card, flipped: true, disabled: true }
						} else return { ...card, flipped: true }
					} else {
						return card
					}
				})
			})
		}
		if (monsterState.hp <= 0) {
			setFloorCards(prevCards => {
				return prevCards.map(card => {
					if (card.type === 'monster' && card.flipped) {
						return { ...card, flipped: true, disabled: true }
					} else {
						return card
					}
				})
			})
			setFloorCardSelected(null)
		}
		// if players turn, then can select floor card or action card if monster card is active
	}, [floorCardSelected, actionCardSelected, monsterState])

	// SETS POTION AND SPELL INVENTORY

	useEffect(() => {
		//console.log('potion: ' + potionInv)
		//console.log('spell: ' + spellInv)
		if (potionInv) {
			setActionCards(prevCards => {
				return prevCards.map(card => {
					if (card.type === 'heal') {
						return { ...card, disabled: false }
					} else {
						return card
					}
				})
			})
		} else if (!potionInv) {
			setActionCards(prevCards => {
				return prevCards.map(card => {
					if (card.type === 'heal') {
						return { ...card, disabled: true }
					} else {
						return card
					}
				})
			})
		}
		if (spellInv) {
			setActionCards(prevCards => {
				return prevCards.map(card => {
					if (card.type === 'magic') {
						return { ...card, disabled: false }
					} else {
						return card
					}
				})
			})
		} else if (!spellInv) {
			setActionCards(prevCards => {
				return prevCards.map(card => {
					if (card.type === 'magic') {
						return { ...card, disabled: true }
					} else {
						return card
					}
				})
			})
		}
	}, [potionInv, spellInv])

	// ATTACKS PLAYER IF MONSTER CARD IS ACTIVE

	useEffect(() => {
		//console.log(playerTurn)
		// if there is a floor card that is FLIPPED & MONSTER & NOT DISABLED then attack player
		const monsterCardActive = floorCards
			.map(card => {
				if (card.type === 'monster' && card.flipped && !card.disabled) {
					//console.log(card.type, card.flipped, card.disabled)
					return true
				} else {
					return false
				}
			})
			.includes(true)
		//console.log(monsterCardActive)
		if (!playerTurn && monsterCardActive === true) {
			//console.log('monster can attack')
			setTimeout(() => {
				goblinSound.play()
				const newHP = playerState.hp - 2
				setPlayerState(prevState => {
					return { ...prevState, hp: newHP }
				})
			}, flipTimer)
		}
	}, [playerTurn])

	// LOCKS OTHER FLOOR CARDS IF MONSTER CARD IS ACTIVE

	useEffect(() => {
		if (floorCardSelected) {
			if (floorCardSelected.type === 'monster') {
				setTimeout(() => {
					setFloorCards(prevCards => {
						return prevCards.map(card => {
							if (card.flipped && !card.disabled && card.type === 'monster') {
								//console.log(card)
								return card
							} else {
								return { ...card, locked: true }
							}
						})
					})
				}, flipTimer)
			}
		}
	}, [playerTurn])

	// UNLOCKS OTHER FLOOR CARDS IF MONSTER IS DEFEATED

	useEffect(() => {
		if (monsterState.hp <= 0) {
			setTimeout(() => {
				setFloorCards(prevCards => {
					return prevCards.map(card => {
						return { ...card, locked: false }
					})
				})
			}, flipTimer)
		}
	}, [monsterState])

	// CHECKS STATUS FOR EITHER NEXT ROOM OR GAME OVER

	useEffect(() => {
		const notAllCardsDisabled = floorCards
			.map(card => {
				if (!card.disabled) {
					return true
				} else {
					return false
				}
			})
			.includes(true)
		if (!notAllCardsDisabled) {
			setGameState({ gameOver: false, nextRoomReady: true })
			setModalOpen(true)
		}
		if (playerState.hp <= 0) {
			setGameState({ gameOver: true, nextRoomReady: false })
			setModalOpen(true)
		}
	}, [playerState, floorCards])

	// GAME INIT, NEXT ROOM, NEW GAME

	useEffect(() => {
		shuffleCards()
		updateActionCards()
		setPlayerTurn(true)
		setScore(0)
		setPlayerState(playerStats)
		setMonsterState(monsterStats)
		setGameState({ gameOver: false, nextRoomReady: false })
		setModalOpen(false)
	}, [])

	const newGame = () => {
		shuffleCards()
		updateActionCards()
		setPlayerTurn(true)
		setScore(0)
		setPlayerState(playerStats)
		setMonsterState(monsterStats)
		setGameState({ gameOver: false, nextRoomReady: false })
		setModalOpen(false)
		setLevelCounter(1)
	}

	const nextRoom = () => {
		shuffleCards()
		setPlayerTurn(true)
		setGameState({ gameOver: false, nextRoomReady: false })
		setModalOpen(false)
		setLevelCounter(prevCounter => {
			return prevCounter + 1
		})
	}

	// MODAL HANDLERS

	const handleModalOpen = () => {
		setModalOpen(true)
	}

	const handleModalClose = () => {
		setModalOpen(false)
	}

	return (
		<div className='App'>
			<div>
				{modalOpen && (
					<div className='modal'>
						<div className='modal-content'>
							<p>{gameState.gameOver ? 'GAME OVER!' : 'Menu'}</p>
							<div className='modal-buttons'>
								<button
									style={gameState.nextRoomReady ? { display: 'block' } : { display: 'none' }}
									onClick={nextRoom}>
									NEXT ROOM
								</button>
								<button onClick={newGame}>New Game</button>
								<button onClick={handleModalClose}>Close</button>
							</div>
						</div>
					</div>
				)}
			</div>
			<div>
				<div className='top-bar'>
					<div className='health'>
						<img src='./assets/ui_heart.png' alt='player-health' />
						<p>{playerState.hp}/15</p>
					</div>
					<div className='status'>
						<p>Caverns of Fortune, Level {levelCounter}</p>
					</div>
					<div className='score'>
						<p>{score}</p>
						<img src='./assets/ui_coin.png' alt='player-score' />
					</div>
				</div>
			</div>
			<div className='floor-deck'>
				{floorCards.map(card => (
					<FloorCard
						key={card.id}
						card={card}
						handleFloorSelection={handleFloorSelection}
						flipped={floorCardSelected || card.flipped}
						disabled={card.disabled}
						locked={card.locked}
					/>
				))}
			</div>
			<div className='action-deck'>
				{actionCards.map(card => (
					<ActionCard key={card.id} card={card} handleActionSelection={handleActionSelection} />
				))}
			</div>
			{monsterState.hp > 0 ? <p className='monster-hp'>Monster HP: {monsterState.hp}</p> : null}
			<button className='menu-button' onClick={handleModalOpen}>
				Menu
			</button>
		</div>
	)
}

export default App

/* Action Plan
	X1. make floor cards stay flipped when selected
	X2. disable floor cards at end of turn depending on outcome
	X2. make action item cards disabled by default, enabled when floor cards permit
	X3. compare floor and action cards and act accordingly
	X4. add  NEXT ROOM (if all cards are disabled) and GAME OVER (if player hp < 0) functionality
	X5. style locked cards and selection hover
	X6. style UI
		Xa. player stats
		Xb. buttons
		Xc. modal
	X7. add delay between card flip and action plus card becoming disabled: monster, potion, spell, treasure
	X8. add sounds and music: X-flip, X-empty, X-attack, X-drink/heal, X-spell, X-coins, X-book, X-bottle, X-monster, X-music loop
	X9. add level counter upon entering new room
	X10. add monster HP tracker
*/
